module.exports = __webpack_public_path__ + "img/uid-token-btn-h.0967a410.png";